import { createSlice, current } from '@reduxjs/toolkit';
import { GROUPS_KEYS } from './groupsConstants';

const initialState = {
  groups: {
    [GROUPS_KEYS.allGroups]: [],
    [GROUPS_KEYS.orderRemotesGroups]: [],
  },
  selectedGroup: {},
};

export const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setGroups: (state, action) => {
      const { groups, groupKey } = action.payload;
      state.groups[groupKey] = groups;
      const { selectedGroup = {} } = current(state);
      // Refresh selected group
      if (selectedGroup?.id) {
        state.selectedGroup = groups.find((g) => g.id === selectedGroup.id);
      }
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
    },
    cleanGroupsSlice() {
      return initialState;
    },
  },
});

export const { cleanGroupsSlice, setGroups, setSelectedGroup } =
  groupsSlice.actions;

export default groupsSlice.reducer;
